import { onEnter } from '@susu/custom-made/utils/utils';
import cn from 'classnames';
import Image from 'next/image';

import styles from './cardListBaseStyle.module.scss';

export default function CardListBaseStyle({
  isPresentationOnly,
  baseStyleClick,
  stylePresetSelectedValue,
}: Readonly<{
  isPresentationOnly?: boolean;
  baseStyleClick?: () => void;
  stylePresetSelectedValue: () => string | null;
}>) {
  return (
    <>
      <div
        className={cn(styles.baseStyle, {
          [styles.isPresentationOnly]: isPresentationOnly,
        })}
        data-test-id="base-style-card"
        onClick={baseStyleClick ?? (() => {})}
        onKeyDown={
          baseStyleClick
            ? e => {
                onEnter(e, () => {
                  baseStyleClick();
                });
              }
            : () => {}
        }
      >
        <div className={styles.baseStyleContainer}>
          <Image src="https://cdn.suitsupply.com/image/upload/svg/base_style.svg" alt="" height={24} width={24} />
        </div>
        <div className={styles.baseStyleTextContainer}>
          <div className={styles.baseStyleText}>Your Style</div>
          <div className={styles.baseStyleDescription} data-test-id="base-style-description">
            {stylePresetSelectedValue()}
          </div>
        </div>
        <div className={styles.edit}>
          <i className="susu-icons" translate="no">
            edit
          </i>
        </div>
      </div>
      <div
        className={cn(styles.arrow, {
          [styles.isPresentationOnly]: isPresentationOnly,
        })}
      >
        <i className="susu-icons" translate="no">
          slight_arrow_right
        </i>
      </div>
    </>
  );
}
